import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-emulated-receipt-modal',
  templateUrl: './emulated-receipt-modal.component.html',
  styleUrls: ['./emulated-receipt-modal.component.scss'],
})
export class EmulatedReceiptModalComponent {
  @Input() receiptText = '';

  @Input() paperWidthChars = 48;

  constructor(private modalCtrl: ModalController) {}

  public dismiss(): void {
    this.modalCtrl.dismiss();
  }
}
